import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=663ec13a&"
import script from "./fullscreen.vue?vue&type=script&lang=ts&"
export * from "./fullscreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fullscreen.vue"
export default component.exports